import { CELL_SIZES } from '../constants';

import { RightSideColumnsType } from '../types';

export const getCellSizes = (columns: RightSideColumnsType) => {
  const filtered = CELL_SIZES.filter((item) => columns[item.name]);

  return filtered.map((item) => item.size).join(' ');
};
